import {
  IBaseConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../models/form-builder-types-configurations.model';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulateRelativeToRootFieldConfig,
  getPopulatesPropsSettingsConfigFormly,
  getUsePrefetchFieldConfig,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getIdConditionsValidatorFormConfig,
  getRequiredValidatorFormConfig,
  getValidationFieldsFormConfig,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-generator.util';
import { FormBuilderService } from '../../../services/form-builder.service';
import {
  getConditionalValidationsFormConfig,
  getConditionalUtilValidatorsFormConfig,
} from '../form-fields-formly-validations/conditional-validations/fields-formly-conditional-validation-field-generator.util';
import { EAvailableConditionalValidations } from '../../../models/form-fields-formly-conditional-validation.model';

export const fieldsBaseConfigurationFormModel =
  (): IBaseConfigurationFormModel => {
    return {
      fieldKey: '',
      fieldLabel: '',
      placeholder: '',
      hint: '',
      tooltip: '',
      internalDescription: '',
      readonly: false,
    };
  };

export const getGenericCustomIdFieldTypeconfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService,
  dataFieldProps: string[]
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: { ...fieldsBaseConfigurationFormModel() },
      formlyForm: [
        ...getDefaultBaseSettingsConfigFormly(formBuilderServiceInstance),
        getUsePrefetchFieldConfig(formBuilderServiceInstance),
        getPopulateRelativeToRootFieldConfig(),
        ...getPopulatesPropsSettingsConfigFormly(
          formBuilderServiceInstance,
          dataFieldProps
        ),
      ],
    },
    validations: {
      formModel: {},
      formlyForm: [
        getRequiredValidatorFormConfig(),
        getIdConditionsValidatorFormConfig(),
        getValidationFieldsFormConfig(formBuilderServiceInstance),
        getConditionalValidationsFormConfig(
          [EAvailableConditionalValidations.required],
          formBuilderServiceInstance
        ),
        getConditionalUtilValidatorsFormConfig(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};
